window.Viewthespace = window.Viewthespace || {};

window.Viewthespace.Pusher = (function() {
  function Pusher() {}

  Pusher.key = window.Viewthespace.pusherKey;

  Pusher.pusher = function() {
    if (window.Pusher instanceof Function) {
      return this._pusher || (this._pusher = new window.Pusher(this.key, window.Viewthespace.pusherOptions));
    }
  };

  return Pusher;
})();
